// Copied from ds/src/app/layouts/Sideblock/Sidebar/Menu/index.tsx
// Changed: replaced SimpleBar with plain div (no simplebar-react dep needed)
import { useLocation } from 'react-router';
import { useLayoutEffect, useRef, useState } from 'react';

import { useDidUpdate } from '@lib/hooks';
import { navigation } from '@/app/navigation';
import { Accordion } from '@lib/ui';
import { isRouteActive } from '@/ds/utils/isRouteActive';
import { Group } from './Group';

export function Menu() {
  const { pathname } = useLocation();
  const ref = useRef<HTMLDivElement | null>(null);

  const activeGroup = navigation.find((item) => {
    if (item.path) return isRouteActive(item.path, pathname);
  });

  const activeCollapsible = activeGroup?.childs?.find((item) => {
    if (item.path) return isRouteActive(item.path, pathname);
  });

  const [expanded, setExpanded] = useState<string | null>(activeCollapsible?.path || null);

  useDidUpdate(() => {
    if (activeCollapsible?.path !== expanded) setExpanded(activeCollapsible?.path || null);
  }, [activeCollapsible?.path]);

  useLayoutEffect(() => {
    const activeItem = ref.current?.querySelector('[data-menu-active=true]');
    activeItem?.scrollIntoView({ block: 'center' });
  }, []);

  return (
    <div ref={ref} className="h-full overflow-x-hidden overflow-y-auto pb-6">
      <Accordion
        value={expanded ?? undefined}
        // Accordion has a type conflict between its custom onChange and HTMLDivElement's native onChange
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(v: any) => setExpanded(Array.isArray(v) ? (v[0] ?? null) : v)}
        className="space-y-1"
      >
        {navigation.map((nav) => (
          <Group key={nav.id} data={nav} />
        ))}
      </Accordion>
    </div>
  );
}
